import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "swiper-close",
  "use": "swiper-close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"swiper-close\"><path d=\"M149.077 993.792a42.667 42.667 0 1 1-60.33-60.33l844.8-844.8a42.667 42.667 0 1 1 60.245 60.415l-844.8 844.8z\" /><path d=\"M88.747 149.077a42.667 42.667 0 0 1 60.33-60.33l844.8 844.8a42.667 42.667 0 1 1-60.416 60.33l-844.8-844.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol